module.exports = __webpack_public_path__ + "img/green-right.3d2ab78c.png";